module.exports = __webpack_public_path__ + "img/poltergeist sisters concert.d3babd9e.png";